import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_AC_PACKAGED_SUB',
  GET: 'GET_AC_PACKAGED_SUB',
  CREATE: 'CREATE_AC_PACKAGED_SUB',
  EDIT: 'EDIT_AC_PACKAGED_SUB',
  DELETE: 'DELETE_AC_PACKAGED_SUB',
  DUPLICATE: 'DUPLICATE_AC_PACKAGED_SUB',
  CLEAR_ERROR: 'CLEAR_ERROR_AC_PACKAGED_SUB',
};

export const clearErrorACPackagedSub = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchACPackagedSubByText = text => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const page = 0;
  const sorted = null;
  const filtered = text;
  const isPublic = null;
  return searchACPackagedSub(pageSize, page, sorted, filtered, isPublic);
};

export const searchACPackagedSub = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_AC_PACKAGED_SUB,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  })
};

export const listACPackagedSub = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchACPackagedSub(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getACPackagedSub = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_AC_PACKAGED_SUB}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createACPackagedSub = (name, powerRequired, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `ac_packaged_sub_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_PACKAGED_SUB,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editACPackagedSub = (id, name, powerRequired, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `ac_packaged_sub_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_PACKAGED_SUB}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteACPackagedSub = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_PACKAGED_SUB}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateACPackagedSub = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_AC_PACKAGED_SUB}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_packaged_unit/ac_packaged_sub_actions.js